import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { RoutesFacade, RouteDirectionFacade, RouteStopsFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import { TimeFromStringPipe } from '@ridango/core/lib/pipes/time-from-string.pipe';

import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-schedule-route-stop-details',
    templateUrl: './route-stop-details.component.html'
})
export class ScheduleRouteStopDetailsComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() routeId = null;
    @Input() directionId = null;
    @Input() stopId = null;
    @Input() quickDeparturesCount = 0;

    scheduleDays$ = this.routeStopsFacade.scheduleDays$;
    departures$ = this.routeStopsFacade.departures$;
    routes$ = this.routesFacade.routes$;
    routeStops$ = this.routeStopsFacade.routeStops$;
    day$ = this.routeStopsFacade.selectedDay$;

    selectedDay = 'today';
    allDepartures = {};
    earlierDepartures = [];
    laterDepartures = {};
    laterHours = [];

    routeName = '';
    directionName = '';
    stopName = '';

    constructor(
        private routesFacade: RoutesFacade,
        private routeDirectionFacade: RouteDirectionFacade,
        private routeStopsFacade: RouteStopsFacade,
        private timeFromString: TimeFromStringPipe,
        private translate: TranslateService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.routesFacade.setSelectedRouteId(this.routeId);
        this.routeDirectionFacade.setSelectedRouteDirection(this.directionId);
        this.routeStopsFacade.setSelectedStop(this.stopId);
        this.routeStopsFacade.setSelectedDay('today');
        this.routeStopsFacade.fetchStopDepartures(this.routeId, this.stopId);
        this.routeStopsFacade.fetchRouteStops(this.routeId, this.directionId);
        this.routeStopsFacade.fetchRoutePolyline(this.routeId, this.directionId);

        this.departures$.pipe(takeUntil(this.componentDestroyed$)).subscribe((departures) => {
            if (departures) {
                this.allDepartures = departures;
                this.findDepartures();
            }
        });

        this.routes$.pipe(takeUntil(this.componentDestroyed$)).subscribe((routes) => {
            if (routes && this.routeId && routes[this.routeId]) {
                this.routeName = routes[this.routeId].route_short_name;
            }
        });

        this.routeDirectionFacade
            .getRouteDirections(this.routeId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((directions) => {
                if (directions) {
                    this.directionName = directions[this.directionId].trip_short_name;
                }
            });

        this.routeStops$.pipe(takeUntil(this.componentDestroyed$)).subscribe((stops) => {
            if (stops && this.stopId && stops[this.stopId]) {
                this.stopName = stops[this.stopId].stop_name;
            }
        });
    }

    ngOnDestroy() {
        this.routeStopsFacade.resetRouteStops();
        super.ngOnDestroy();
    }

    changeDay(day) {
        this.routeStopsFacade.setSelectedDay(day);
        this.findDepartures(day);
    }

    findDepartures(day = 'today') {
        const departuresOfDay = this.allDepartures[day];
        this.earlierDepartures = [];
        this.laterHours = [];
        this.laterDepartures = {};

        let count = 0;
        if (departuresOfDay && departuresOfDay.length > 0) {
            departuresOfDay.forEach((departure) => {
                if (departure.direction_id === this.directionId) {
                    if (day === 'today' && count < this.quickDeparturesCount) {
                        this.earlierDepartures.push(departure);
                    } else {
                        const hour = this.timeFromString.transform(departure.departure_time, 'hh');
                        if (!this.laterHours.includes(hour)) {
                            this.laterHours.push(hour);
                            this.laterDepartures[hour] = [];
                        }
                        this.laterDepartures[hour].push(departure);
                    }
                    count++;
                }
            });
        }
    }

    back() {
        this.router.navigate(
            [this.translate.currentLang, 'schedule', 'routes', this.routeId, 'directions', this.directionId]
        );
    }
}
